module.exports = "tr {\r\n\tcursor: pointer; \r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/assays/samples/sample-list/sample-list.component.css
// module id = ./src/app/assays/samples/sample-list/sample-list.component.css
// module chunks = main